import {TSpeech} from '../types/types'

export function filterSpeechByCategory(speeches: TSpeech[], category: string) {
  return speeches.filter(
    speech => speech.category.toLowerCase() === category.toLowerCase()
  )
}
